export default __webpack_public_path__ + "static/media/escoffier_culinary_education.6f01b0f1.jpg";